import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/return.png';
import _imports_1 from '../assets/image/link_r.png';

import { useRouter } from 'vue-router';
import { ref, reactive, onMounted } from 'vue';
const _withScopeId = n => (_pushScopeId("data-v-dc717a60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "tk-head-nav flex-between"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: ""
};
const _hoisted_5 = {
  class: "tk-head-info"
};
export default {
  __name: 'headNav',
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {
      type: Boolean,
      default: true
    },
    video: {
      type: String,
      default: ""
    },
    top: {
      type: Boolean,
      default: false
    }
  },
  emits: ["morelottery", "returnUp"],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const route = useRouter();
    let scrollTabs = ref(null);
    let scroolData = reactive({
      offsetTop: 0
    });
    let morelottery = () => {
      emits("morelottery");
    };
    onMounted(() => {
      // 获取 DOM 元素
      scroolData.offsetTop = scrollTabs.value?.clientHeight;
    });
    let returnUp = () => {
      //返回上一页
      if (props.video != "") {
        emits("returnUp");
      } else {
        callNativeApp("back");
        route.back();
      }
    };
    let callNativeApp = back => {
      try {
        // 從JS傳送資訊到App裡設定的callbackHandler。
        webkit.messageHandlers.callbackHandler.postMessage(back);
      } catch (err) {
        // 如果找不到定義的callbackHandler則回傳錯誤訊息。
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "tk-main-head-nav",
        ref_key: "scrollTabs",
        ref: scrollTabs
      }, [__props.type ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "tk-head-return",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(returnUp) && _unref(returnUp)(...args))
      }, _hoisted_3), _createElementVNode("div", {
        class: "tk-head-title",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(morelottery) && _unref(morelottery)(...args))
      }, [_createElementVNode("span", null, _toDisplayString(__props.title), 1), __props.top ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "iocn")])])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "tkCont")], 512), _createElementVNode("div", {
        style: _normalizeStyle({
          height: _unref(scroolData).offsetTop + 'px'
        })
      }, null, 4)], 64);
    };
  }
};